
import { defineComponent } from 'vue'
import { Post } from '@/model/data-object/Post'
import usePostSingleLoader, {
  usePostUpdate,
} from '@/composables/post/postSinleLoader'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import PostText from '@/components/Forms/PostText.vue'
import PostEditTimer from '@/components/Post/SinglePost/PostEditTimer.vue'
import { MAX_EDIT_OPENED_AGE } from '@/composables/post/postEdit'

export default defineComponent({
  name: 'PostEdit',
  emits: ['post-updated', 'post-close'],
  components: { PostEditTimer, PostText, AButton, AIcon },
  props: {
    post: {
      type: Post,
      required: true,
    },
    postEditing: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      timesUp: false,
      timeToEdit: MAX_EDIT_OPENED_AGE,
    }
  },
  async setup(props, { emit }) {
    const postRaw = await usePostSingleLoader(props.post)

    return {
      postRaw,
      ...usePostUpdate(
        postRaw?.value ? (postRaw.value as Post) : new Post(),
        emit
      ),
    }
  },
})
